// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorMessage_errorMessage__kPiCQ {
    border: 1px solid red;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 14px;
    color: red;
    border-radius: 4px;
    background: #fff;
    text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/_components/errorMessage/errorMessage.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B","sourcesContent":[".errorMessage {\n    border: 1px solid red;\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    font-size: 14px;\n    color: red;\n    border-radius: 4px;\n    background: #fff;\n    text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `errorMessage_errorMessage__kPiCQ`
};
export default ___CSS_LOADER_EXPORT___;
